import { useQuery } from '@tanstack/react-query';
import { useRepository } from '@city-sage/aurum-avis-labs-components';
import { Leg } from '@city-sage/core-client';
import { QueryKeys } from '../lib/QueryKeys';

interface UseLegsByItineraryParams {
  itineraryId: string;
  enabled?: boolean;
}

export const useLegsByItinerary = ({ 
  itineraryId, 
  enabled = true 
}: UseLegsByItineraryParams) => {
  const { api } = useRepository();

  return useQuery({
    queryKey: QueryKeys.itinerary.legs(itineraryId),
    queryFn: async (): Promise<Leg[]> => {
      const response = await api.findAllItineraryLeg({
        itineraryId,
        limit: 1000 // Get all legs for the itinerary
      });
      return response;
    },
    enabled: enabled && !!itineraryId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
